<div class="grid grid-cols-1 gap-4 mt-1 rounded-xl ">
  <div class="bg-white rounded-lg">
    <div class="flex flex-col md:flex-row justify-between items-center p-4 md:px-6 gap-3">
      
      <div class="w-full flex gap-2 md:w-auto">
        <input
          type="search"
          class="input-c"
          placeholder="Search by product code"
          [(ngModel)]="searchParams().productCode"
          (keyup.enter)="getAllProducts()"
          (search)="getAllProducts()"
        />
        <button type="button" (click)="getAllProducts()"
                class="button-blue w-full sm:w-auto">
          Search
        </button>
      </div>

    </div>
    <div class="md:mx-6 md:mb-6 overflow-x-auto">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500 table-auto">
        <thead class="text-xs whitespace-nowrap text-gray-700 bg-gray-50">
        <tr>
          <th class="px-3 py-2 md:px-4 md:py-3">Product Code</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Product Name</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Department</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Customer</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Production Details</th>
        </tr>
        </thead>
        <tbody>
          @for (product of products(); track product._id) {
            <tr class="bg-white border-b whitespace-nowrap hover:bg-gray-50 text-gray-600">
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.productCode }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.generalData?.productName }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5 uppercase">{{ product.department  }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.generalData?.customer }}</td>
              <td class="px-2 py-3">
                  <div class="flex items-center gap-2">
                    <button type="button" class="button-blue-outline w-full sm:w-auto" (click)="openProductionDataView(product.productCode)">View</button>
                    <button [disabled]="product.productionData?.productionDataAdded" type="button" class="button-blue-outline w-full sm:w-auto" (click)="addProductionData(product.productCode)">Add</button>
                    <button [disabled]="!product.productionData?.productionDataAdded" type="button" class="button-blue-outline w-full sm:w-auto" (click)="openProductionDataEdit(product.productCode)">Edit</button>
                  </div>
              </td>

            </tr>
          } @empty {
            <tr>
              <td colspan="9" class="px-6 py-10">
                <div class="flex flex-col items-center justify-center text-center">
                  <p class="text-md font-semibold text-gray-700 mb-2">No result found</p>
                  <p class="text-gray-500">We couldn't find any search result that match your search
                    criteria.</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="mt-4">
        <app-table-pagination [totalItems]="totalItems()" [itemsPerPage]="itemsPerPage()"
                              (pageChanged)="onPageChange($event)"></app-table-pagination>
      </div>
    </div>
  </div>
</div>

@if (modal.$$showProductionDataModal()) {
    <div
    class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50"
    tabindex="-1"
    (keyup.escape)="closeProductionDataModal()"
  >
    <div class="relative p-4 w-full max-w-4xl max-h-full">
      <div class="relative bg-white rounded-lg shadow-xl">

        <!-- HEADER -->
        <div class="flex items-center justify-between p-4 md:p-6 border-b rounded-t">
          <h3 class="text-lg font-semibold text-gray-900">
            Production Data View
          </h3>

          <button
            type="button"
            (click)="closeProductionDataModal()"
            class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 inline-flex justify-center items-center"
          >
            ✕
          </button>
        </div>

        <!-- BODY -->
        <div class="p-6 space-y-6">

          @if (productionData()) {

            <!-- MATERIALS -->
            @if (productionData()?.materials?.length) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Materials</h4>
                <ul class="list-disc pl-6 text-sm">
                  @for (m of productionData()?.materials; track m.sequence) {
                    <li>
                      Material {{ m.sequence }}:
                      <span *ngIf="m.materialCode" class="font-medium text-blue-700 mr-1">{{ m.materialCode }}</span>
                      {{ m.material }}
                    </li>
                  }
                </ul>
              </section>
            }

            <!-- INKS -->
            @if (productionData()?.inks?.length) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Inks</h4>
                <ul class="list-disc pl-6 text-sm">
                  @for (ink of productionData()?.inks; track ink.sequence) {
                    <li>Ink {{ ink.sequence }}: {{ ink.ink }}</li>
                  }
                </ul>
              </section>
            }

            <!-- VARNISHES -->
            @if (productionData()?.varnishes?.length) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Varnishes</h4>
                <ul class="list-disc pl-6 text-sm">
                  @for (v of productionData()?.varnishes; track v.sequence) {
                    <li>Varnish {{ v.sequence }}: {{ v.varnish }}</li>
                  }
                </ul>
              </section>
            }

            <!-- SCREENS -->
            @if (productionData()?.screens?.length) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Screens</h4>
                <ul class="list-disc pl-6 text-sm">
                  @for (s of productionData()?.screens; track s.sequence) {
                    <li>Screen {{ s.sequence }}: {{ s.screen }}</li>
                  }
                </ul>
              </section>
            }

            <!-- FINISHING OPTIONS -->
            <section class="border rounded-lg p-4">
              <h4 class="font-semibold mb-3">Finishing Options</h4>
              <div class="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span class="text-gray-500">Cold Foil</span>
                  <p class="font-medium">{{ productionData()?.coldFoil }}</p>
                </div>

                <div>
                  <span class="text-gray-500">Hot Foil</span>
                  <p class="font-medium">{{ productionData()?.hotFoil }}</p>
                </div>

                <div>
                  <span class="text-gray-500">Embossing</span>
                  <p class="font-medium">{{ productionData()?.embossing }}</p>
                </div>

                <div>
                  <span class="text-gray-500">Lamination</span>
                  <p class="font-medium">{{ productionData()?.lamination }}</p>
                </div>

                <div class="col-span-2">
                  <span class="text-gray-500">Die Cut Code</span>
                  <p class="font-medium">{{ productionData()?.dieCutCode }}</p>
                </div>
              </div>
            </section>
          }
        </div>
      </div>
    </div>
  </div>
}